export default function theme(scene, backgroundMaterial) {
    const themeBtn = document.getElementById('theme-toggle')

    const updateBackground = (isDark) => {
        if (isDark) {
            backgroundMaterial.uniforms.centerColor.value.set(0x777777)
            backgroundMaterial.uniforms.edgeColor.value.set(0x555555)
        } else {
            backgroundMaterial.uniforms.centerColor.value.set(0xf2f3f5)
            backgroundMaterial.uniforms.edgeColor.value.set(0xdadce0)
        }
    };

    const savedTheme = localStorage.getItem('theme')
    const isInitiallyDark = savedTheme === 'dark'

    if (isInitiallyDark) {
        document.body.classList.add('dark-theme')
    } else {
        document.body.classList.remove('dark-theme')
    }

    updateBackground(isInitiallyDark)

    themeBtn.addEventListener('click', () => {
        document.body.classList.toggle('dark-theme')
        const isDark = document.body.classList.contains('dark-theme')
        localStorage.setItem('theme', isDark ? 'dark' : 'light')

        updateBackground(isDark)
    })
}

